import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
  <div data-testid={`chapter-${index}`} className="flex items-center gap-3 mb-5">
    <span
      className={`font-mono-orbit text-xs font-semibold tracking-widest ${
        dark ? "text-emerald-400" : "text-emerald-500"
      }`}
    >
      {index}
    </span>
    <span className={`h-px w-10 ${dark ? "bg-emerald-400/50" : "bg-emerald-500/50"}`} />
    <span
      className={`text-xs font-semibold uppercase tracking-[0.22em] ${
        dark ? "text-slate-300" : "text-slate-500"
      }`}
    >
      {label}
    </span>
  </div>
);

export const Logo = ({ dark = false, className = "h-9" }) => (
  <img
    src={dark ? "/assets/orbit-logo-white.png" : "/assets/orbit-logo.png"}
    alt="Orbit — Operational reporting & BI tracker"
    data-testid="orbit-logo"
    className={`w-auto ${className}`}
  />
);
